import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import { OrchestratorRecognizedResponse } from 'types/api/recognized';
import { FetchRecognizedOptions } from 'types/api/reissuance';
import { FetchResponse } from 'types/fetch';
import { getErmEnabledCookieValue } from '../cookies';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

/* START GENAI@GHCOPILOT */
export function fetchOrchestratorRecognize({
  apikey,
  sessionId,
  isBiometricsEnabledDevice,
  isVdiDisabled,
  idToken
}: FetchRecognizedOptions): FetchResponse<
  OrchestratorRecognizedResponse,
  OrchestratorErrorResponse
> {
  const ermEnabled = getErmEnabledCookieValue();
  let query = `srcClientId=${apikey}`;

  const headers: Record<string, string> = {
    dfpSessionId: sessionId
  };

  if (idToken) {
    headers.id_token = idToken;
  }

  if (ermEnabled?.authRef) {
    headers.activity_ref = ermEnabled.authRef;
    query += '&activityRefBody=true';
  }

  if (isBiometricsEnabledDevice) {
    query += `&isBiometricsEnabledDevice=${isBiometricsEnabledDevice}`;
  }

  if (isVdiDisabled) {
    query += `&isVdiDisabled=${isVdiDisabled}`;
  }

  return fetchReq({
    headers,
    mark: 'fetch_recognize_orchestrated',
    method: 'GET',
    url: `${endpoints.orchestrator.recognize}?${query}`,
    waitForVbaToken: false
  });
}
/* END GENAI@GHCOPILOT */
